import React from 'react'

import { VStack } from '~/components/elements/VStack'

import { useSelectedBrands } from '../hooks/useSelectedBrands'

import { Output } from './Output'

export const Outputs = () => {
  const selectedBrands = useSelectedBrands()

  return (
    <VStack spacing={8}>
      {selectedBrands.map((brand) => (
        <Output key={brand.id} brand={brand} />
      ))}
    </VStack>
  )
}
